import * as configuration from '@/infrastructure/Configuration'
import { DateFactory } from 'rhg-vue-common'
import SearchTypes from '@/domain/SearchTypes'
import ExternalStorage from '@/services/ExternalStorage'
import { redirect } from '@/infrastructure/Utils'
import { contentApi } from '../infrastructure/Configuration'

class NewRdBookingService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async preBooking(availabilityRequest, stay, customer, rooms) {
    const preferredCurrency = global.Cookie.read(window.cookieDictionary.preferredCurrency)

    const headers = {
      'X-Currency': preferredCurrency || 'EUR'
    }
    if (ExternalStorage.session.transactionId()) {
      headers.transactionId = ExternalStorage.session.transactionId()
    }

    const taxIncludedRegion = ExternalStorage.cookies.taxIncludedRegion()
    const taxExcludedRegion = ExternalStorage.cookies.taxExcludedRegion()
    const preBookingRequest = this._mapPreBookingRequest(
      availabilityRequest,
      stay,
      customer,
      taxIncludedRegion,
      taxExcludedRegion,
      rooms
    )
    const response = await this.httpClient.post(configuration.apiInitiate, preBookingRequest, {
      headers
    })
    return response?.data
  }

  _mapPreBookingRequest(availabilityRequest, stay, customer, taxIncludedRegion, taxExcludedRegion, rooms) {
    const { searchType, promotionCode } = availabilityRequest

    const request = {
      searchType: availabilityRequest.searchType,
      promotionCode: searchType === SearchTypes.ECERT ? promotionCode.toUpperCase() : promotionCode,
      checkInDate: DateFactory.formatDate(DateFactory.dateObject(availabilityRequest.checkInDate)),
      checkOutDate: DateFactory.formatDate(
        DateFactory.dateObject(availabilityRequest.checkOutDate)
      ),
      hotelCode: availabilityRequest.hotelCode,
      occupancies: availabilityRequest.occupancies,
      rates: stay.rates,
      roomCode: stay.roomId,
      facilitatorId: availabilityRequest.facilitatorId,
      merchantId: availabilityRequest.merchantId,
      rezidorProperty: availabilityRequest.rezidorProperty,
      isWebView: ExternalStorage.global.isWebView(),
      sourceOfBusiness: ExternalStorage.global.sourceOfBusiness(),
      taxIncludedRegion:
        (taxIncludedRegion ? true : undefined) || (taxExcludedRegion ? false : undefined),
      dealOfTheDay: stay.dealOfTheDay,
      voucherCode: availabilityRequest.voucher || undefined,
      tier: customer?.tier,
      rooms
    }

    if (ExternalStorage.session.promotionalCodeGroupId()) {
      request.groupId = ExternalStorage.session.promotionalCodeGroupId()
    }

    if (ExternalStorage.session.travelAgencyCustomerId()) {
      request.customerId = ExternalStorage.session.travelAgencyCustomerId()
    }

    if (stay.tierDiscount && availabilityRequest.tierDiscount) {
      request.tierDiscount = availabilityRequest.tierDiscount
    }

    if (customer?.rewardsNumber) {
      request.userLogin = { rewardsNumber: customer.rewardsNumber }
    }

    if (customer?.crowd) {
      request.userLogin = { ...request.userLogin, crowd: customer.crowd }
    }

    if (customer?.programType) {
      request.userLogin = { ...request.userLogin, programType: customer.programType }
    }

    return request
  }

  async getUpsellConfig() {
    return this.httpClient.get(`${contentApi}/upselling/config`)
  }

  async redirectToCheckout({ preBookingId, canApplyUpsellings, hotelCode }) {
    const { altFacilitatorId, facilitatorId, siteId, RK } = ExternalStorage.url.params
    const params = {
      preBookingId,
      brandOptIn: ExternalStorage.session.brandOptIn(),
      brandPreference: ExternalStorage.session.brandPreference()
    }
    if (altFacilitatorId) params.altFacilitatorId = altFacilitatorId
    if (facilitatorId) params.facilitatorId = facilitatorId
    if (siteId) params.siteId = siteId
    if (RK) params.RK = RK

    if (canApplyUpsellings) {
      try {
        const response = await this.getUpsellConfig()

        if ((response?.data?.hideInUpsellingPage || []).includes(hotelCode)) {
          redirect(configuration.checkoutPageUrl, params)
        } else {
          redirect(configuration.upsellingPageUrl, params)
        }
      } catch (e) {
        redirect(configuration.upsellingPageUrl, params)
      }
    } else {
      redirect(configuration.checkoutPageUrl, params)
    }
  }
}

export default NewRdBookingService
